import { Heading, Text, Box, Stack, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

export default function Resume({
  bg,
  title,
  subtitle,
  link,
  linkLabel,
  children,
  ...rest
}) {
  return (
    <Stack
      maxH={["unset", "240px"]}
      height="190px"
      p={["22px 20px", "6"]}
      color="white"
      justify="space-between"
      bgImage={bg}
      bgRepeat="no-repeat"
      bgSize="cover"
      pos="relative"
      borderRadius="12px"
      overflow="hidden"
      {...rest}
    >
      <Box>
        <Box
          width="20px"
          height="5px"
          color="#8AD657"
          bgColor="#8AD657"
          borderRadius="6px"
          mb="8px"
        />
        <Heading
          as="h3"
          fontSize={{ lg: "16px", "2xl": "18px" }}
          lineHeight="28px"
          fontWeight={700}
          maxW="76%"
        >
          {title}
        </Heading>
        <Text fontSize="sm" lineHeight="30px">
          {subtitle}
        </Text>
      </Box>

      <Button
        as={Link}
        to={`${link}` || "#"}
        variant="link"
        pos="absolute"
        bottom="32px"
      >
        <Text
          as="span"
          fontSize="16px"
          fontWeight={600}
          textDecor="underline"
          lineHeight="normal"
          color="white"
        >
          {linkLabel}
        </Text>
      </Button>
      {children}
    </Stack>
  );
}
